import { isDefined } from "@clipboard-health/util-ts";
import { CircularProgress } from "@mui/material";
import { useCurrentUserId } from "@src/appV2/ExperimentalHomeHealth/lib/useCurrentUserId";
import { useIsHomeHealthEnabled } from "@src/appV2/ExperimentalHomeHealth/lib/useIsHomeHealthEnabled";
import { HOME_HEALTH_VISIT_VERIFICATION_PATH } from "@src/appV2/ExperimentalHomeHealth/VisitVerification/paths";
import { useIsMobileDevice } from "@src/appV2/redesign/AppLayout/useResponsive";
import { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

import { HOME_HEALTH_VISIT_VERIFICATION_MOBILE_PATH } from "./paths";

const MobileVisitVerificationPage = lazy(
  async () =>
    await import("./Page").then((module) => ({
      default: module.MobileVisitVerificationPage,
    }))
);

export function ProtectedMobileVisitVerificationPage() {
  const currentUserId = useCurrentUserId();
  const isLoggedIn = isDefined(currentUserId);
  const isHomeHealthEnabled = useIsHomeHealthEnabled();

  const isMobile = useIsMobileDevice();

  if (!isLoggedIn) {
    localStorage.setItem("redirectURL", HOME_HEALTH_VISIT_VERIFICATION_MOBILE_PATH);
    return <Redirect to={`/enter?requestedUrl=${HOME_HEALTH_VISIT_VERIFICATION_MOBILE_PATH}`} />;
  }

  if (!isHomeHealthEnabled) {
    localStorage.removeItem("redirectURL");
    return <Redirect to="/" />;
  }

  if (!isMobile) {
    return <Redirect to={HOME_HEALTH_VISIT_VERIFICATION_PATH} />;
  }

  return (
    <Suspense fallback={<CircularProgress />}>
      <MobileVisitVerificationPage />
    </Suspense>
  );
}
